import isNil from 'lodash/isNil';

export default function calculateTax(taxPercent = 0, taxPercentSurcharge, totalPayment, totalSurcharge) {
  const totalVat = Math.round(
    !isNil(taxPercentSurcharge) ? (totalPayment * taxPercent) / 100 : ((totalPayment + totalSurcharge) * taxPercent) / 100
  );
  return totalVat;
}
